import { gql } from '@/__generated__';

/** Conexión y batería de la compuerta del movimiento, de la caché de última lectura del backend. */
export const GET_GATE_READINGS = gql(`#graphql
  query GetGateReadings($movementId: Int!) {
    gateMovement(id: $movementId) {
      id
      state
      gate {
        id
        movements2 {
          id
          lastConnection {
            connected
            source
            timestamp
          }
          lastBattery {
            value
            unit
            precision
            source
            timestamp
          }
        }
      }
    }
  }
`);
